import { ReactComponent as IconAccountSetting } from "@/assets/svgs/account-setting.svg";
import { ReactComponent as IconNotificationSetting } from "@/assets/svgs/notification-setting.svg";
import Portal from "@/components/Portal/index.js";
import Tabs, { Tab } from "@/components/Tabs";
import usePage from "@/hooks/use-page/index.js";
import { useState, useEffect } from "react";
import { AccountSetting } from "./components/account-setting.jsx";
import { NotificationSetting } from "./components/notification-setting.jsx";
import { NavLink, useNavigate, useLocation } from "@/lib/router-dom/index.js";
import Breadcrumbs from "@/componentsDS/Breadcrumbs/index.jsx";

const Page = ({ setLoading }) => {
	// const location = useLocation();
	const { currentPath } = useLocation();
	const { replace } = useNavigate();

	const pageTitle = "Account Settings";

	const defaultBreadCrumbs = {
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: `/`,
			},
			{
				label: 'Account Settings',
				link: `/setting/account`
			},
		],
	};

	useEffect(() => {
		if(currentPath === "/setting"){
			replace("/setting/account")
		}
	}, [])

	useEffect(() => {
		const newTabItems = tabsItems.map((item) => ({
			...item,
			active: item.path === currentPath,
		}));
		setTabItems(newTabItems);
	}, [currentPath]);

	const defaultTabItems = [
		{
			title: "My Account",
			label: (
				<NavLink className="setting-btn" to="/setting/account">
					<IconAccountSetting />
					<div className="setting-btn-txt font-weight-bold">My Account</div>
				</NavLink>
			),
			path: "/setting/account",
			active: true,
		},
		{
			title: "Notifications",
			label: (
				<NavLink className="setting-btn" to="/setting/notification">
					<IconNotificationSetting />
					<div className="setting-btn-txt font-weight-bold">Notifications</div>
				</NavLink>
			),
			path: "/setting/notification",
			active: false,
		},
	];

	const [tabsItems, setTabItems] = useState(
		defaultTabItems.map((item) => ({
			...item,
			active: item.path === currentPath,
		}))
	);

	const { breadcrumbsItems } = usePage(defaultBreadCrumbs);

	const selectTab = (item) => {
		const newTabItems = tabsItems.map((value) => {
			value.active = item.path === value.path;
			return value;
		});
		setTabItems(newTabItems);
	};

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title font-weight-bold">{pageTitle}</div>
				</div>
			</div>

			<div>
				<Tabs>
					{tabsItems.map((item, index) => (
						<Tab
							key={index}
							label={item.label}
							active={item.active}
							onClick={() => selectTab(item)}
						/>
					))}
				</Tabs>
			</div>
			<div className="eclip-hr">
				<hr />
			</div>
			{currentPath === "/setting/account" && (
				<AccountSetting setLoading={setLoading} />
			)}
			{currentPath === "/setting/notification" && (
				<NotificationSetting setLoading={setLoading} />
			)}
		</>
	);
};

export default Page;
